import axios, { AxiosRequestConfig } from "axios";
import { FastTrackScout } from "../organisation/model/fastTrack";

const getAxiosConfig = (jwtToken: string): AxiosRequestConfig => {
  return {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
};

export const getFastTrackScouts = (
  jwtToken: string,
  callback: (scouts: FastTrackScout[]) => void,
  onError?: (errorMsg: string) => void
) => {
  axios
    .get(`https://api.triangula.com/backoffice/fast-track/scouts`, getAxiosConfig(jwtToken))
    .then((response) => {
      if (response.status === 200) {
        callback(response.data.scouts);
      } else if (onError) {
        onError("Failed to fetch fast track scouts");
      }
    })
    .catch(() => {
      if (onError) {
        onError("Failed to fetch fast track scouts");
      }
    });
};
